module.exports = __webpack_public_path__ + "media/images/facebook-7b60c1ed0411cedb762116b20fbcb7d4.svg";